import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {useHistory} from "react-router-dom";
import {sideMenuContext} from "../../../router/IndexRouter";
import {Arguments} from "../common/Arguments";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import EditComponent from "../common/EditComponent";
import DeleteComponent from "../common/DeleteComponent";
import SearchBox from "../common/SearchBoxComponent";


export default function MeetingNoticeAdmin(props) {
    const history = useHistory();
    const currentUrl = window.location.href;
    const {dataSource, setDataSource, setCopyDataSource, setCurrentItem} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/policy/api!meetingNotice.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const handleTitleClick = (item) => {
        setCurrentItem(item);
        history.push(`/system/meeting-notice-admin/${item.meetingId}`);
    };

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '标题',
            dataIndex: 'title',
            width: 400,
            render: (title, item) => (
                <Button type="link" onClick={() => {
                    handleTitleClick(item)
                }}><b>{title}</b></Button>
            )
        },
        {
            title: '通知日期',
            dataIndex: 'publishDate',
            width: 140,
            sorter: (a, b) => a.publishDate.localeCompare(b.publishDate),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '优先级',
            dataIndex: 'grade',
            width: 120,
            sorter: (a, b) => a.grade - b.grade,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '是否有效',
            dataIndex: 'status',
            width: 140,
            sorter: (a, b) => a.status.localeCompare(b.status),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: "操作",
            width: 140,
            render: (item) => (
                <>
                    <EditComponent item={item} url={currentUrl}/>
                    <DeleteComponent
                        item={item}
                        postApi={[Arguments.host + "/society_organization/policy/api!addMeetingNotice.do"]}
                        getApi={getApi}
                    />
                </>
            )
        }
    ];

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <Button type="primary" onClick={() => props.history.push("/system/meeting-notice-admin/add")}
                    style={{marginBottom: 10}}>新增</Button>
            <SearchBox placeholder="输入标题关键字"/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}




